import React, { useEffect } from "react";
import styles from "./GuestRsvpCelebrate.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { useNavigate } from "react-router-dom";
import flowerImg from "../../../../assets/rsvpFlower.png";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
const GuestRsvpCelebrate = () => {
  const EventDetails = useSelector(
    (state) => state?.GuestReducer?.EventDetails
  );
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(EventPlanningMiddleware.getRsvp(EventDetails?.id));
  }, []);
  return (
    <div className={styles.mainCont}>
      {RSVP?.invite_type == "message" ? (
        <>
          <div className={styles.imgdiv}>
            <img src={flowerImg} />
          </div>
          <TextComponent text={RSVP?.tagline} textClass={styles.heading} />
          <div className={styles.description}>
            <TextComponent text={RSVP?.message} />
          </div>
        </>
      ) : (
        <div className={styles.tempCont}>
          <img src={RSVP?.template_image} alt="" />
        </div>
      )}
      <TextComponent
        text={`${EventDetails?.groom?.first_name} & ${EventDetails?.bride?.first_name}`}
        textClass={styles.heading2}
      />
      <TextComponent text={EventDetails?.name} textClass={styles.title} />
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Next"
          btnClass={styles.btn}
          onClick={() =>
            navigate("/RsvpDetails", {
              state: { headrTitle: "RSVP" },
            })
          }
        />
      </div>
    </div>
  );
};

export default GuestRsvpCelebrate;
